import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { RadioGroup } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";

import { SliceStopCountFilter } from "../../../../types";
import defaultStyles from "./FilterStops.module.scss";

export interface IStopsOption {
  value: SliceStopCountFilter;
  label: string;
}

export interface FilterStopsComponentProps {
  value: SliceStopCountFilter;
  onStopFilterChange: (value: SliceStopCountFilter) => void;
}

export const FilterStops = (props: FilterStopsComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.FilterStops;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { value, onStopFilterChange } = props;
  const { t } = useI18nContext();

  const stopsOptions: IStopsOption[] = [
    {
      label: t("searchFilter.anyStop"),
      value: SliceStopCountFilter.ANY_NUMBER,
    },
    {
      label: t("searchFilter.noStops"),
      value: SliceStopCountFilter.NONE,
    },
    {
      label: t("searchFilter.oneOrFewerStops"),
      value: SliceStopCountFilter.ONE_OR_LESS,
    },
    {
      label: t("searchFilter.twoOrFewerStops"),
      value: SliceStopCountFilter.TWO_OR_LESS,
    },
  ];

  const onSelectOption = (value: string) => {
    if (SliceStopCountFilter[value]) {
      return onStopFilterChange(SliceStopCountFilter[value]);
    }
    console.error("Invalid stop count filter value");
  };

  return (
    <RadioGroup
      options={stopsOptions}
      selectedOption={value}
      onSelectValue={onSelectOption}
      className={block}
    />
  );
};
